export const DEV_EMAILS: string[] = ["mshahba9@asu.edu", "hbisht1@asu.edu"];
export const QA_EMAILS: string[] = ["rgupt181@asu.edu"];
export const LEAD_EMAILS: string[] = ["relango@asu.edu"];

export const DEV_AND_LEAD_EMAILS = [...DEV_EMAILS, ...LEAD_EMAILS];
export const ALL_TEAM_EMAILS = [...DEV_EMAILS, ...QA_EMAILS, ...LEAD_EMAILS];
